import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-report',
  templateUrl: './stock-report.component.html',
  styleUrls: ['./stock-report.component.css']
})
export class StockReportComponent implements OnInit {

  public menu_item_id = '53';
  
  private dp = [];
  report_result = {};

  displayedColumns = ['sub_item_number', 'sub_item_no', 'main_item_name', 'item_subcat_name', 
    'unit_name', 'baseline_amount', 'available_count'];

  // displayedColumns2 = ['sub_item_number', 'sub_item_no', 'main_item_name', 'item_subcat_name', 
  //   'unit_name', 'stock_no', 'baseline_amount', 'available_count'];

  // displayedColumns2 = ['sub_item_number', 'sub_item_no', 'main_item_name', 'main_item_name_en', 'unit_name',
  //   'store_name', 'available_count'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'type': 'stock_report', 'branch_id': '0', 'store_id': '0', 'sub_item_no': '', 
    'title': 'تقرير المخزون' };

  Stock_Report; Select;
  Branch; Store; Sub_Item;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Stock_Report').subscribe((res: string) => {
      this.Stock_Report = res;
    });
    this.model['title'] = this.Stock_Report;

    translate.get('Select').subscribe((res: string) => {
      this.Select = res;
    });

    translate.get('Branch').subscribe((res: string) => {
      this.Branch = res;
    });

    translate.get('Store').subscribe((res: string) => {
      this.Store = res;
    });

    translate.get('Sub_Item').subscribe((res: string) => {
      this.Sub_Item = res;
    });

  }

  ngOnInit() {
  }

  onChangeRepResult = function (report_result: object) {
    console.log(report_result);

    this.report_result = report_result;
    if (this.report_result['by_detail'] == '0') {
      this.displayedColumns = ['sub_item_number', 'sub_item_no', 'main_item_name', 'item_subcat_name', 
        'unit_name', 'baseline_amount', 'available_count'];
    }
    else {
      this.displayedColumns = ['sub_item_number', 'sub_item_no', 'main_item_name', 'item_subcat_name', 
        'unit_name', 'stock_no', 'expiry_date', 'baseline_amount', 'available_count', 'total_cost', 
        'total_price', 'final_total'];
    }

    this.dp = this.report_result['list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;
  }

  search() {

    let obj;
    if (this.model['sub_item_no'] == '')
      obj = { cmd: 'getAvailableStock', store_id: this.model['store_id'] };
    else
      obj = { cmd: 'getAvailableStock', store_id: this.model['store_id'], sub_item_no: this.model['sub_item_no'] };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') {
          this.dp = data.status['msg'];
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        }
        else
          alert(data.status['msg']);
      });
  }

  print() {

    let html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Branch + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['branch_name'] : this.report_result['branch_name_en']);
    html_data += '</td>';

    html_data += '<td width="50%"> ' + this.Store + ': ' + 
      (this.applicationConstants.user_lang == 'ar' ? this.report_result['store_name'] : this.report_result['store_name_en']);
    html_data += '</td></tr>';

    if (this.report_result['sub_item_name'] != '')
      html_data += '<tr><td colspan="2"> ' + this.Sub_Item + ': ' + this.report_result['sub_item_name'] + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('stock_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
